import template from './swag-paypal-settings-icon.html.twig';
import './swag-paypal-settings-icon.scss';

export default Shopware.Component.wrapComponentConfig({
    template,
});
